import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";
import { isStaging } from "@/webflow/is-staging";

export default function (element, dataset) {
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top 80%",
    },
  });

  tl.from(element, {
    opacity: 0,
    scale: 0.95,
    x: -4,
  });

  onDestroy(() => {
    tl.kill();
  });
}
